<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-button type="primary" style="margin-left:70px; border-radius: 5px;" @click="saveTemplate">保存</a-button>
      <div class="content">
        <div class="list_text">
          <div class="label_text">收费标准预览：</div>
          <div class="onimg">
            <img :src="form.imgs" alt="" style="width:100%;height:100%;" v-image-preview>
          </div>
        </div>
        <div class="list_text selectType" style="margin-top: 20px;">
          <div class="label_text">指定包邮：</div>
           <a-radio-group v-model="form.type" @change="setRadio">
            <a-radio value="true">开启</a-radio>
            <a-radio value="false">关闭</a-radio>
          </a-radio-group>
        </div>
        <div v-if="form.type=='true'">
          <div class="list_text" style="margin-top: 20px;">
            <div class="label_text">添加包邮邮区域：</div>
            <a-button type="primary" v-if="form.region.length<1" style="margin-left:15px; border-radius: 5px;" @click="addCity(1)">选择包邮区域</a-button>
          </div>
          <a-table :columns="columns" :data-source="form.region" :pagination="false"
            :rowKey="(record,index)=>{return index}" class="tempBox">
            <template slot="index" slot-scope="text, record,index">
              <div>{{index+1}}</div>
            </template>
            <div slot="areaInfos" slot-scope="text, record">
              <div class="custorhand" @click="editCity(1,record)">
                <template v-if="record.iSselect">
                  <div class="text-left text-bold">全国</div>
                </template>
                <template v-else>
                  <span class="text-left" v-for="(item, index) in record.areaInfos" :key="index">
                    <!-- 如果省全选，则只展示省不展示市，如果省没有全选 市要展示 -->
                    <span v-if="item.cityNum == item.selectedNum" class="text-bold">{{ item.province + ',' }}</span>
                    <div v-else>
                      <span class="text-bold">{{ item.province }}</span>
                      <span>: {{ item.title }}</span>
                    </div>
                  </span>
                </template>
              </div>
            </div>
 
            <template slot="action" slot-scope="text, record">
              <a href="javascript:void(0)" @click="editCity(1,record)" style="color:bule;">修改</a>
              <a href="javascript:void(0)" @click="confirmEdit(form.region, record, 1)" style="color:red;margin-left:15px;">删除</a>
            </template>
          </a-table>

        </div>
      </div>

      <city ref="city" @selectCity="selectCity" :type="type" :id="curAddressId"
      :otherSelectedArr="otherSelectedArr"
      :selectArr="selectArr"
      :acityList="cityList">
    </city>
    </a-card>

     


  </page-header-wrapper>
</template>

<script>
import city from '../../mall/template/city.vue';
import { guid } from '@/utils/ruoyi.js'
import { getConfig,updateConfig } from '@/api/system/config'
import { freightCreate,freightUpdate,freightGet,freightDelete } from '@/api/freight/index'
import { mapGetters } from 'vuex'
export default {
  components: {
    city
  },
 

  data() {
    return {
      configData:null,
      typeName:'',
      type: 0, // 0添加 1编辑
      curAddressId: 0,
      otherSelectedArr: [],
      selectArr: [], // 传递选中的城市
      cityList: [],
      columns: [
        {
          width: 100,
          dataIndex: 'index',
          title: '序号',
          scopedSlots: { customRender: 'index' }
        },
        {
        
          dataIndex: 'areaInfos',
          title: '可配送区域',
          scopedSlots: { customRender: 'areaInfos' }
        },{
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          title: '操作',
          width: 150
        }
      ],

        form:{
            imgs:'',
            type:'false',
            region:[]
        }
    }
  },
  created() {
    
  },
   computed: {
    ...mapGetters(['acityList', 'cityTotalNum'])
  },
  watch: {},
  mounted() {
    this.getAgreement()
    this.getData()
    
  },
  methods: {
    //基础信息
    getAgreement(){
        let id='539503142497320960'
         getConfig(id).then(res => {
          if(res.code=='20001'){
            this.configData = res.data
            this.form.imgs = res.data.configValue
            this.form.type = res.data.remark
          }
        })
    },
    setRadio(){
    
      this.configData.remark = this.form.type
      updateConfig(this.configData).then(res => { 
        if(res){
          this.$message.success('指定包邮修改成功！')
        }
       
      })
    },
    //基础数据获取
    getData(){
      freightGet().then(res=>{
        console.log(res,'plplplplp');
        if(res.code=='20001'){
          if(res.data.length==0){
            this.typeName = 'add'
            this.form.region = []
          }else{
            this.typeName = 'edit'
            let regionList = res.data
            console.log(regionList);
            
            if(regionList.length) {
              regionList.forEach((item,index)=>{
                let selectedCityNum = 0
                if(!item.id) item.id = guid(8,10)
                item.data = []
                item.areaInfos.forEach((item1,index1)=>{
                  
                  let obj = {
                    "areaName": item.province,
                    "areaId": item.provinceId,
                    "children": []
                  }
                  let cityIdsArr = item1.cityIds.split(",")
                  cityIdsArr.forEach((item2,index2)=>{
                    
                    obj.children.push({
                      "areaId": item2
                    })
                  })
                  item1.selectedNum = cityIdsArr.length
                  selectedCityNum += cityIdsArr.length
                  item1.cityNum = this.getAreaNum(item1.provinceId)
                  item.data.push(obj)
                })
                if(selectedCityNum == this.cityTotalNum) item.iSselect = true
              })
              this.setBtnShow(regionList, 'isSelectAllregion')
          }
          this.form.region = regionList
            
          }
        }
      })
    },


    /**添加配送区域
     * 显示选择城市弹窗
     */
    addCity(type) {
      this.selectArr = []
      this.type = type;
      /** 获取 已经选中的城市数组,要置灰,不可勾选 */
      this.otherSelectedArr = []
      if(type == 1) {
        this.form.region.forEach((item, index)=>{
          this.otherSelectedArr.push(...item.data)
        })
      }else if(type == 2) {
        this.form.free.forEach((item, index)=>{
          this.otherSelectedArr.push(...item.data)
        })
      }

      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },

    /**
     * 编辑城市区域弹窗
     */
    editCity(type, record) {
      console.log(type, record);
      
      this.type = type;
      this.curAddressId = record.id
      this.selectArr = []
      this.selectArr = record.data
      /** 获取 除当前这条数据以外其他的选中的城市数组 */
      this.otherSelectedArr = []
      if(type == 1) {
        this.form.region.forEach((item, index)=>{
          if(item.id != record.id) {
            this.otherSelectedArr.push(...item.data)
          }
        })
      }else if(type == 2) {
        this.form.free.forEach((item, index)=>{
          if(item.id != record.id) {
            this.otherSelectedArr.push(...item.data)
          }
        })
      }

      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },

    /**
     * 删除所选城市
     */
    confirmEdit(areaArr, record, type) {

      freightDelete(record).then(res=>{ 
        if(res){
          this.$message.success('删除成功！');
          this.getData()
        }
      })
      
      // let delIndex = areaArr.findIndex(item=>{return item.id == record.id})
      // areaArr.splice(delIndex, 1)
      // let str = ''
      // type == 1 ? str = 'isSelectAllregion' : str = 'isSelectAllfree'
      // this.setBtnShow(areaArr, str)
    },

    /**
     * 控制 添加城市按钮 显示隐藏
     */
    setBtnShow(arr, fieldname) {
      let selectedNum = 0
      arr.forEach((item)=>{
        item.data.forEach((item1)=>{
          selectedNum += item1.children.length
        })
      })
      selectedNum == this.cityTotalNum ? this[fieldname] = true : this[fieldname] = false
    },


    /**获取某个省下面的市的个数 */
    getAreaNum(cityId) {
      let num = 0
      this.acityList.forEach((item,index)=>{
        console.log(cityId);
        
        if(item.areaId == cityId) {
          num = item.children.length
        }
      })
      return num
    },

    /**
     * 计算是否是全选
     */
    setisSelect(arr) {
      let selectedNum = 0
      arr.forEach((item)=>{
        selectedNum += item.children.length
      })
      return selectedNum == this.cityTotalNum ? true : false
    },



    /**添加配送区域
     * 选择城市后处理数据
     */
    selectCity(obj) {
      window.console.log('选择城市后得到的城市数组 data', obj)
      let data = obj.selectList, type = obj.type, iSselect = obj.iSselect, editedIndex = -1

      if(obj.isEdit) {
        // 编辑
        if(obj.type == 1) {
          editedIndex = this.form.region.findIndex(item=>{return item.id == obj.id})
        }else if(obj.type == 2){
          editedIndex = this.form.free.findIndex(item=>{return item.id == obj.id})
        }
      }

      let areaInfos = []
      data.forEach(item => {
        let aobj = {
          provinceId: item.areaId,
          province: item.areaName,
          title: '',
          cityIds: '',
          cityNum: item.cityNum,
          selectedNum: item.children.length
        }
        if (item.children) {
          aobj.cityIds = item.children.map(item1 => { return item1.areaId }).join(",")
          aobj.title = item.children.map(item1 => { return item1.areaName }).join(",")
        }
        areaInfos.push(aobj)
      })
      switch (type) {
        case 1:
          if(obj.isEdit) {
            // 编辑
            let flag = this.setisSelect(obj.selectList)

            this.$set(this.form.region[editedIndex], 'areaInfos', areaInfos)
            this.$set(this.form.region[editedIndex], 'data', obj.selectList)
            this.$set(this.form.region[editedIndex], 'iSselect', flag)
          }else{
            // 新增
              this.form.region.push({
              id: guid(8,10),
              iSselect: iSselect,
              areaInfos: areaInfos,
              first: 0,
              firstPrice: 0,
              renewal: 1,
              renewalPrice: 0,
              data: obj.selectList
            });
          }
          console.log('this.form.region',this.form.region)
          /**控制添加配送区域按钮显示隐藏 */
          this.setBtnShow(this.form.region, 'isSelectAllregion')
          break;
        case 2:
          if(obj.isEdit) {
            // 编辑
            let flag = this.setisSelect(obj.selectList)
            this.form.free[editedIndex].areaInfos = areaInfos
            this.form.free[editedIndex].data = obj.selectList
            this.$set(this.form.free[editedIndex], 'iSselect', flag)
          }else{
            this.form.free.push({
              id: guid(8,10),
              iSselect: iSselect,
              areaInfos: areaInfos,
              number: 0,
              price: 0,
              data: obj.selectList
            });
            console.log('this.form.free',this.form.free)
          }
          this.setBtnShow(this.form.free, 'isSelectAllfree')
          break;
        case 3:
          this.noDeliveryList.push({
            place: data,
            placeName: cityName,
          });
          this.noDeliveryArr = this.noDeliveryArr.concat(data);
          break;
      }
    },

    // 保存
    saveTemplate(){
      if(this.typeName=='add'){
        freightCreate(this.form.region).then(res=>{
          if(res){
            this.$message.success('保存成功！');
            this.getData()
          }

        })
      }else{
        freightUpdate(this.form.region).then(res=>{
          if(res){
            this.$message.success('修改成功！');
            this.getData()
          }

        })
      }
      
    },




  }
}
</script>

<style scoped>
.content{
  margin-top: 20px;
  margin-left: 20px;
  height: 70vh;
}
.list_text{
    display: flex;
}

.label_text{
  width: 150px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
}
.onimg{
    margin-left: 10px;
    width: 100px;
    height: 100px;
    background: #ccc;
    border-radius: 10px;
    overflow: hidden;
}

.selectType{
  display: flex;
  align-items: center;
}
.tempBox{
  margin-top: 15px;
}

</style>
